<template>
  <div class="chart-container">
    <VChart :option="chartOptions" autoresize v-if="hasChartSeries" />
    <div class="font-italic text-muted w-100 h-100" v-if="!hasChartSeries" style="display: flex">
      <div class="m-auto">No data available</div>
    </div>
  </div>
</template>

<style scoped>
.chart-container {
  width: 100%;
  height: 100%;
}
</style>

<script>
import _ from 'lodash'

import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { PieChart } from 'echarts/charts';
import { TitleComponent, TooltipComponent, LegendComponent } from 'echarts/components';
import VChart, { THEME_KEY } from 'vue-echarts';

use([
  CanvasRenderer,
  PieChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
]);

export default {
  name: 'ChartDoughnut',
  components: {
    VChart
  },
  props: {
    series: Array,
    legend: [Array, Object],
    options: Object
  },
  computed: {
    hasChartSeries() {
      if(this.series) {
        return this.series.some(series => {
          if(series.data && series.data.length > 0)
            return true
        })
      }
      return false
    },
    chartOptions() {
      var output = {}

      // Default options
      output.tooltip = {
        trigger: 'item',
        formatter: '{a} <br/>{b} : {c} ({d}%)',
        confine: true
      },
      
      output.legend = {
        orient: 'vertical',
        left: 'right',
        data: []
      }
      output.series = [{
        title: '',
        type: 'pie',
        radius: ['50%', '80%'],
        center: ['35%', '50%'],
        left: 'left',
        labelLayout: {
          hideOverlap: true
        },
        label: {
          show: true,
          formatter(param) {
            return param.name + ` - ${param.value}`;
          }
        },
        labelLine: {
          show: true
        },
        data: [],
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)',
          },
        },
      }]

      _.merge(output, this.options)
      _.merge(output.series, this.series)
      _.merge(output.legend, this.legend)

      return output
    }
  }  
}
</script>